// import { TextField, MenuItem, Button } from "@mui/material";
// import { useContext, useEffect, useState } from "react";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import { useParams } from "react-router-dom";
// import { CapitalCompositionFinepModel } from "../../../../Models/CapitalCompositionModel";
// import { CreateCapitalCompositionFinep, GetCapitalCompositionFinep, ValidateCapitalCompositionFinep } from "../../../../API/CapitalCompositionFinepAPI";
// import Loader from "../../../../Components/Shared/Loader";
// import { useAuth } from "../../../../Hooks/useAuth";
// import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
// import { EditAnonymousSocietyCompanyFINEP } from "../../../../API/CompanyFinepAPI";

// const CapitalCompositionFinepTab = () => {
//     const [loading, setLoading] = useState(false);
//     const [document, setDocument] = useState("");
//     const [fullName, setFullName] = useState("");
//     const [votingCapital, setVotingCapital] = useState("");
//     const [isController, setIsController] = useState(false);
//     const [validateField, setValidateField] = useState(false);
//     const user = useAuth();
//     const { companyId, registerId } = useParams();
//     const { changeTab, handleFillTab, handleInvalidateTab, handleValidateTab, company } = useContext(CompanyFinepContext);
//     const [isAnonymousSociety, setIsAnonymousSociety] = useState(company?.isAnonymousSociety ? company.isAnonymousSociety === true ? "1" : "0" : "0");

//     const [capitalCompositionList, setCapitalCompositionList] = useState<CapitalCompositionFinepModel[]>([]);

//     async function handleAddCapitalComposition() {
//         setLoading(true);
//         const capitalComposition: CapitalCompositionFinepModel = {
//             companyFINEPId: companyId,
//             votingCapital: votingCapital,
//             document: document,
//             fullName: fullName,
//             isController: isController,
//             pulverizacaoCapitalSocial: "",
//             isValid: false,
//             isContentValid: false,
//             userEmail: user.userEmail,
//         }

//         await CreateCapitalCompositionFinep(capitalComposition)
//             .catch(x => setLoading(false));

//         handleFillTab(4);

//         setCapitalCompositionList([...capitalCompositionList, capitalComposition]);
//         setLoading(false);
//         setVotingCapital("");
//         setDocument("");
//         setFullName("");
//     }

//     async function getCapitalComposition() {
//         setLoading(true);

//         if (companyId) {
//             await GetCapitalCompositionFinep(companyId)
//                 .then((x: CapitalCompositionFinepModel[]) => {
//                     if (x) {
//                         handleFillTab(4);

//                         if (x.some(y => y.isContentValid)) {
//                             handleValidateTab(4);
//                             setValidateField(true);
//                         }
//                     }

//                     setCapitalCompositionList(x)
//                 })
//                 .catch(x => setLoading(false));
//         }

//         setLoading(false);
//     }

//     async function handleValidate(isValid: boolean) {
//         setLoading(true);

//         setValidateField(isValid);

//         await ValidateCapitalCompositionFinep({
//             companyFinepId: companyId ?? "",
//             isContentValid: isValid,
//             userEmail: user.userEmail
//         }).then(x => {
//             if (isValid) {
//                 handleValidateTab(4);
//             }
//             else {
//                 handleInvalidateTab(4);
//             }
//         })
//             .catch(x => setLoading(false));

//         setLoading(false);
//     }

//     async function handlechangeAnonymousSociety() {
//         setLoading(true);

//         await EditAnonymousSocietyCompanyFINEP({
//             id: companyId ?? "",
//             isAnonymousSociety: isAnonymousSociety === "1",
//             userEmail: user.userEmail
//         }).catch(x => setLoading(false));

//         setLoading(false);
//     }

//     useEffect(() => {
//         getCapitalComposition();
//     }, [])

//     return (
//         <>
//             {loading && <Loader />}
//             <TabsHeader
//                 canValidate={true}
//                 valueSelected={validateField}
//                 changeValidate={handleValidate}
//                 registerId={registerId}
//                 cardName="Pessoa Jurídica"
//                 tabName="Composição do Capital Social"
//             />
//             <form >
//                 <h4 className="mt-4">
//                     <strong className="blue">Cadastro Pessoa Jurídica - Proponente ou Executora</strong>
//                 </h4>
//                 <p className="gray">Informações primárias da empresa</p>
//                 <strong className="d-block mt-4 mb-4">Composição do Capital Social</strong>
//                 <table className="table table-bordered table-hover">
//                     <thead>
//                         <tr>
//                             <th>
//                                 <strong className="blue">Capital Votante</strong>
//                             </th>
//                             <th>
//                                 <strong className="blue">CNPJ/CPF</strong>
//                             </th>
//                             <th>
//                                 <strong className="blue">Nome Completo do Sócio ou Acionista</strong>
//                             </th>
//                             <th>
//                                 <strong className="blue">Controlador</strong>
//                             </th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {capitalCompositionList.map((capital, index) => {
//                             return (
//                                 <tr key={index}>
//                                     <td>{capital.votingCapital}</td>
//                                     <td>{capital.document}</td>
//                                     <td>{capital.fullName}</td>
//                                     <td>{capital.isController ? 'Sim' : 'Não'}</td>
//                                 </tr>
//                             )
//                         })}
//                     </tbody>
//                 </table>
//                 <div className="d-flex mt-4">
//                     <TextField
//                         type="text"
//                         label="Capital Votante"
//                         className="w-100 me-4"
//                         value={votingCapital}
//                         onChange={(e) => setVotingCapital(e.target.value)}
//                         defaultValue={''}
//                     />
//                     <TextField
//                         type="text"
//                         label="CNPJ/CPF"
//                         className="w-100 me-4"
//                         value={document}
//                         onChange={(e) => setDocument(e.target.value)}
//                     />
//                     <TextField
//                         type="text"
//                         label="Nome Completo do Sócio ou Acionista"
//                         className="w-100 me-4"
//                         value={fullName}
//                         onChange={(e) => setFullName(e.target.value)}
//                     />
//                     <TextField
//                         label="Controlador"
//                         className="w-100"
//                         value={isController ? "1" : "0"}
//                         onChange={(e) => setIsController(e.target.value === "1")}
//                         select
//                         defaultValue=""
//                     >
//                         <MenuItem value="1">Sim</MenuItem>
//                         <MenuItem value="0">Não</MenuItem>
//                     </TextField>
//                 </div>
//                 <div className="mt-4 mb-4 d-flex justify-content-end">
//                     <Button variant="contained" type="button" onClick={handleAddCapitalComposition}>
//                         + Socio ou Acionista
//                     </Button>
//                 </div>
//                 <div className="mt-4 d-flex align-items-center ">
//                     <strong className="d-block me-4 mt-4 mb-4">Em caso de sociedade anônima, há pulverização de seu capital social de modo a não se identificar o seu controlador?</strong>
//                     <TextField
//                         select
//                         className="select-width"
//                         placeholder="Selecione"
//                         value={isAnonymousSociety}
//                         onChange={(e) => setIsAnonymousSociety(e.target.value)}
//                         required
//                         onBlur={handlechangeAnonymousSociety}
//                     >
//                         <MenuItem value="1">Sim</MenuItem>
//                         <MenuItem value="0">Não</MenuItem>
//                     </TextField>
//                 </div>
//                 <div className="d-flex justify-content-end mt-4 mb-4">
//                     <Button variant="contained" className="me-4" type="button" onClick={() => changeTab(5)}>Próxima Etapa</Button>
//                     <Button variant="outlined" className="" type="button" onClick={() => changeTab(3)} >Voltar</Button>
//                 </div>
//             </form>
//         </>
//     )
// };

// export default CapitalCompositionFinepTab;




// import { useContext, useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import {
//     Input,
//     Button,
//     Select,
//     Table,
//     Typography,
//     Form,
//     Switch,
//     message
// } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import { CapitalCompositionFinepModel } from "../../../../Models/CapitalCompositionModel";
// import {
//     CreateCapitalCompositionFinep,
//     GetCapitalCompositionFinep,
//     ValidateCapitalCompositionFinep
// } from "../../../../API/CapitalCompositionFinepAPI";
// import Loader from "../../../../Components/Shared/Loader";
// import { useAuth } from "../../../../Hooks/useAuth";
// import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
// import { EditAnonymousSocietyCompanyFINEP } from "../../../../API/CompanyFinepAPI";
// const { Title, Text } = Typography;
// const CapitalCompositionFinepTab = () => {
//     const [loading, setLoading] = useState(false);
//     const [document, setDocument] = useState("");
//     const [fullName, setFullName] = useState("");
//     const [votingCapital, setVotingCapital] = useState("");
//     const [isController, setIsController] = useState(false);
//     const [validateField, setValidateField] = useState(false);
//     const user = useAuth();
//     const { companyId, registerId } = useParams();
//     const {
//         changeTab,
//         handleFillTab,
//         handleInvalidateTab,
//         handleValidateTab,
//         company
//     } = useContext(CompanyFinepContext);
//     const [isAnonymousSociety, setIsAnonymousSociety] = useState(
//         company?.isAnonymousSociety ? "1" : "0"
//     );
//     const [capitalCompositionList, setCapitalCompositionList] = useState<CapitalCompositionFinepModel[]>([]);
//     const columns = [
//         {
//             title: <Text strong style={{ color: '#1890ff' }}>Capital Votante</Text>,
//             dataIndex: 'votingCapital',
//             key: 'votingCapital',
//             width: '25%',
//         },
//         {
//             title: <Text strong style={{ color: '#1890ff' }}>CNPJ/CPF</Text>,
//             dataIndex: 'document',
//             key: 'document',
//             width: '25%',
//         },
//         {
//             title: <Text strong style={{ color: '#1890ff' }}>Nome Completo</Text>,
//             dataIndex: 'fullName',
//             key: 'fullName',
//             width: '30%',
//         },
//         {
//             title: <Text strong style={{ color: '#1890ff' }}>Controlador</Text>,
//             dataIndex: 'isController',
//             key: 'isController',
//             width: '20%',
//             render: (isController: boolean) => isController ? 'Sim' : 'Não'
//         },
//     ];
//     async function handleAddCapitalComposition() {
//         if (!votingCapital || !document || !fullName) {
//             message.error("Preencha todos os campos obrigatórios");
//             return;
//         }
//         setLoading(true);
//         const capitalComposition: CapitalCompositionFinepModel = {
//             companyFINEPId: companyId,
//             votingCapital,
//             document,
//             fullName,
//             isController,
//             pulverizacaoCapitalSocial: "",
//             isValid: false,
//             isContentValid: false,
//             userEmail: user.userEmail,
//         };
//         try {
//             await CreateCapitalCompositionFinep(capitalComposition);
//             setCapitalCompositionList([...capitalCompositionList, capitalComposition]);
//             setVotingCapital("");
//             setDocument("");
//             setFullName("");
//             setIsController(false);
//             message.success("Sócio/Acionista adicionado com sucesso!");
//             handleFillTab(4);
//         } catch (error) {
//             message.error("Erro ao adicionar sócio/acionista");
//         } finally {
//             setLoading(false);
//         }
//     }
//     async function getCapitalComposition() {
//         setLoading(true);
//         try {
//             if (companyId) {
//                 const data = await GetCapitalCompositionFinep(companyId);
//                 if (data) {
//                     handleFillTab(4);
//                     if (data.some(item => item.isContentValid)) {
//                         handleValidateTab(4);
//                         setValidateField(true);
//                     }
//                     setCapitalCompositionList(data);
//                 }
//             }
//         } catch (error) {
//             message.error("Erro ao carregar composição de capital");
//         } finally {
//             setLoading(false);
//         }
//     }
//     async function handleValidate(isValid: boolean) {
//         setLoading(true);
//         try {
//             await ValidateCapitalCompositionFinep({
//                 companyFinepId: companyId ?? "",
//                 isContentValid: isValid,
//                 userEmail: user.userEmail
//             });
//             setValidateField(isValid);
//             if (isValid) {
//                 handleValidateTab(4);
//             } else {
//                 handleInvalidateTab(4);
//             }
//             message.success("Validação atualizada com sucesso!");
//         } catch (error) {
//             message.error("Erro ao validar composição de capital");
//         } finally {
//             setLoading(false);
//         }
//     }
//     async function handleChangeAnonymousSociety() {
//         setLoading(true);
//         try {
//             await EditAnonymousSocietyCompanyFINEP({
//                 id: companyId ?? "",
//                 isAnonymousSociety: isAnonymousSociety === "1",
//                 userEmail: user.userEmail
//             });
//             message.success("Informação atualizada com sucesso!");
//         } catch (error) {
//             message.error("Erro ao atualizar informação");
//         } finally {
//             setLoading(false);
//         }
//     }
//     useEffect(() => {
//         getCapitalComposition();
//     }, []);
//     return (
//         <>
//             {loading && <Loader />}
//             <TabsHeader
//                 canValidate={true}
//                 valueSelected={validateField}
//                 changeValidate={handleValidate}
//                 registerId={registerId}
//                 cardName="Pessoa Jurídica"
//                 tabName="Composição do Capital Social"
//             />
//             <Title level={4} className="mt-4">
//                 <strong className="blue">Cadastro Pessoa Jurídica - Proponente ou Executora</strong>
//             </Title>
//             <Text type="secondary">Informações primárias da empresa</Text>
//             <Title level={5} className="mt-4 mb-4">
//                 <strong>Composição do Capital Social</strong>
//             </Title>
//             <Table
//                 columns={columns}
//                 dataSource={capitalCompositionList}
//                 rowKey={(record, index) => index?.toString() || record.document}
//                 bordered
//                 pagination={false}
//                 locale={{
//                     emptyText: (
//                         <Text type="secondary">Nenhum sócio/acionista cadastrado</Text>
//                     )
//                 }}
//                 style={{ marginBottom: 24 }}
//             />
//             <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
//                 <Form.Item style={{ flex: 1 }}>
//                     <Input
//                         placeholder="Capital Votante"
//                         value={votingCapital}
//                         onChange={(e) => setVotingCapital(e.target.value)}
//                     />
//                 </Form.Item>
//                 <Form.Item style={{ flex: 1 }}>
//                     <Input
//                         placeholder="CNPJ/CPF"
//                         value={document}
//                         onChange={(e) => setDocument(e.target.value)}
//                     />
//                 </Form.Item>
//                 <Form.Item style={{ flex: 1 }}>
//                     <Input
//                         placeholder="Nome Completo do Sócio ou Acionista"
//                         value={fullName}
//                         onChange={(e) => setFullName(e.target.value)}
//                     />
//                 </Form.Item>
//                 <Form.Item style={{ flex: 0.5 }}>
//                     <Select
//                         placeholder="Controlador"
//                         value={isController ? "1" : "0"}
//                         onChange={(value) => setIsController(value === "1")}
//                     >
//                         <Select.Option value="1">Sim</Select.Option>
//                         <Select.Option value="0">Não</Select.Option>
//                     </Select>
//                 </Form.Item>
//             </div>
//             <div style={{ marginBottom: 24, textAlign: 'right' }}>
//                 <Button
//                     type="primary"
//                     icon={<PlusOutlined />}
//                     onClick={handleAddCapitalComposition}
//                 >
//                     Adicionar Sócio/Acionista
//                 </Button>
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                 <Text strong style={{ marginRight: 16 }}>
//                     Em caso de sociedade anônima, há pulverização de seu capital social de modo a não se identificar o seu controlador?
//                 </Text>
//                 <Select
//                     style={{ width: 120 }}
//                     value={isAnonymousSociety}
//                     onChange={(value) => {
//                         setIsAnonymousSociety(value);
//                         handleChangeAnonymousSociety();
//                     }}
//                 >
//                     <Select.Option value="1">Sim</Select.Option>
//                     <Select.Option value="0">Não</Select.Option>
//                 </Select>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
//                 <Button type="primary" onClick={() => changeTab(5)}>
//                     Próxima Etapa
//                 </Button>
//                 <Button onClick={() => changeTab(3)}>
//                     Voltar
//                 </Button>
//             </div>
//         </>
//     );
// };
// export default CapitalCompositionFinepTab;


















import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Input, Button, Select, Table, Typography, Form, Space, Popconfirm, message } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import { CapitalCompositionFinepModel } from "../../../../Models/CapitalCompositionModel";
import {
    CreateCapitalCompositionFinep,
    GetCapitalCompositionFinep,
    ValidateCapitalCompositionFinep
} from "../../../../API/CapitalCompositionFinepAPI";
import Loader from "../../../../Components/Shared/Loader";
import { useAuth } from "../../../../Hooks/useAuth";
import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
import { EditAnonymousSocietyCompanyFINEP } from "../../../../API/CompanyFinepAPI";
const { Title, Text } = Typography;
const CapitalCompositionFinepTab = () => {
    const [loading, setLoading] = useState(false);
    const [document, setDocument] = useState("");
    const [fullName, setFullName] = useState("");
    const [votingCapital, setVotingCapital] = useState("");
    const [isController, setIsController] = useState(false);
    const [validateField, setValidateField] = useState(false);
    const [editingId, setEditingId] = useState<string | null>(null);
    const [editData, setEditData] = useState<CapitalCompositionFinepModel | null>(null);
    const user = useAuth();
    const { companyId, registerId } = useParams();
    const {
        changeTab,
        handleFillTab,
        handleInvalidateTab,
        handleValidateTab,
        company
    } = useContext(CompanyFinepContext);
    const [isAnonymousSociety, setIsAnonymousSociety] = useState(
        company?.isAnonymousSociety ? "1" : "0"
    );
    const [capitalCompositionList, setCapitalCompositionList] = useState<CapitalCompositionFinepModel[]>([]);
    const handleEdit = (record: CapitalCompositionFinepModel) => {
        setEditingId(record.id || '');
        setEditData({ ...record });
    };
    const handleCancelEdit = () => {
        setEditingId(null);
        setEditData(null);
    };
    const handleSaveEdit = async () => {
        if (!editData) return;
        setLoading(true);
        try {

            setCapitalCompositionList(capitalCompositionList.map(item =>
                item.id === editData.id ? editData : item
            ));
            setEditingId(null);
            setEditData(null);
            message.success("Registro atualizado com sucesso!");
        } catch (error) {
            message.error("Erro ao atualizar registro");
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (id: string) => {
        setLoading(true);
        try {
            setCapitalCompositionList(capitalCompositionList.filter(item => item.id !== id));
            message.success("Registro excluído com sucesso!");
        } catch (error) {
            message.error("Erro ao excluir registro");
        } finally {
            setLoading(false);
        }
    };
    const columns = [
        {
            title: <Text>Capital Votante</Text>,
            dataIndex: 'votingCapital',
            key: 'votingCapital',
            width: '25%',
            render: (text: string, record: CapitalCompositionFinepModel) => {
                if (editingId === record.id) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Input
                                value={editData?.votingCapital}
                                onChange={(e) => setEditData({
                                    ...editData!,
                                    votingCapital: e.target.value
                                })}
                            />
                        </Form.Item>
                    );
                }
                return text;
            },
        },
        {
            title: <Text>CNPJ/CPF</Text>,
            dataIndex: 'document',
            key: 'document',
            width: '25%',
            render: (text: string, record: CapitalCompositionFinepModel) => {
                if (editingId === record.id) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Input
                                value={editData?.document}
                                onChange={(e) => setEditData({
                                    ...editData!,
                                    document: e.target.value
                                })}
                            />
                        </Form.Item>
                    );
                }
                return text;
            },
        },
        {
            title: <Text>Nome Completo</Text>,
            dataIndex: 'fullName',
            key: 'fullName',
            width: '25%',
            render: (text: string, record: CapitalCompositionFinepModel) => {
                if (editingId === record.id) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Input
                                value={editData?.fullName}
                                onChange={(e) => setEditData({
                                    ...editData!,
                                    fullName: e.target.value
                                })}
                            />
                        </Form.Item>
                    );
                }
                return text;
            },
        },
        {
            title: <Text>Controlador</Text>,
            dataIndex: 'isController',
            key: 'isController',
            width: '15%',
            render: (isController: boolean, record: CapitalCompositionFinepModel) => {
                if (editingId === record.id) {
                    return (
                        <Form.Item style={{ margin: 0 }}>
                            <Select
                                value={editData?.isController ? "1" : "0"}
                                onChange={(value) => setEditData({
                                    ...editData!,
                                    isController: value === "1"
                                })}
                                style={{ width: '100%' }}
                            >
                                <Select.Option value="1">Sim</Select.Option>
                                <Select.Option value="0">Não</Select.Option>
                            </Select>
                        </Form.Item>
                    );
                }
                return isController ? 'Sim' : 'Não';
            },
        },
        {
            title: 'Ações',
            key: 'actions',
            width: '10%',
            align: 'center' as const,
            render: (_: any, record: CapitalCompositionFinepModel) => {
                if (editingId === record.id) {
                    return (
                        <Space size="middle">
                            <Button
                                type="primary"
                                onClick={handleSaveEdit}
                                icon={<SaveOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                            <Button
                                onClick={handleCancelEdit}
                                icon={<CloseOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                        </Space>
                    );
                }
                return (
                    <Space size="middle">
                        <Button
                            onClick={() => handleEdit(record)}
                            icon={<EditOutlined />}
                            style={{ border: 'none', boxShadow: 'none', color: 'blue' }}
                        />
                        <Popconfirm
                            title="Tem certeza que deseja excluir este registro?"
                            onConfirm={() => handleDelete(record.id || '')}
                            okText="Sim"
                            cancelText="Não"
                        >
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                style={{ border: 'none', boxShadow: 'none' }}
                            />
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];
    async function handleAddCapitalComposition() {
        if (!votingCapital || !document || !fullName) {
            message.error("Preencha todos os campos obrigatórios");
            return;
        }
        setLoading(true);
        const capitalComposition: CapitalCompositionFinepModel = {
            companyFINEPId: companyId,
            votingCapital,
            document,
            fullName,
            isController,
            pulverizacaoCapitalSocial: "",
            isValid: false,
            isContentValid: false,
            userEmail: user.userEmail,
        };
        try {
            const response = await CreateCapitalCompositionFinep(capitalComposition);
            setCapitalCompositionList([...capitalCompositionList, {
                ...capitalComposition,
                id: response.id
            }]);
            setVotingCapital("");
            setDocument("");
            setFullName("");
            setIsController(false);
            message.success("Sócio/Acionista adicionado com sucesso!");
            handleFillTab(4);
        } catch (error) {
            message.error("Erro ao adicionar sócio/acionista");
        } finally {
            setLoading(false);
        }
    }
    async function getCapitalComposition() {
        setLoading(true);
        try {
            if (companyId) {
                const data = await GetCapitalCompositionFinep(companyId);
                if (data) {
                    handleFillTab(4);
                    if (data.some((item: CapitalCompositionFinepModel) => item.isContentValid)) {
                        handleValidateTab(4);
                        setValidateField(true);
                    }
                    setCapitalCompositionList(data);
                }
            }
        } catch (error) {
            message.error("Erro ao carregar composição de capital");
        } finally {
            setLoading(false);
        }
    }
    async function handleValidate(isValid: boolean) {
        setLoading(true);
        try {
            await ValidateCapitalCompositionFinep({
                companyFinepId: companyId ?? "",
                isContentValid: isValid,
                userEmail: user.userEmail
            });
            setValidateField(isValid);
            if (isValid) {
                handleValidateTab(4);
            } else {
                handleInvalidateTab(4);
            }
            message.success("Validação atualizada com sucesso!");
        } catch (error) {
            message.error("Erro ao validar composição de capital");
        } finally {
            setLoading(false);
        }
    }
    async function handleChangeAnonymousSociety() {
        setLoading(true);
        try {
            await EditAnonymousSocietyCompanyFINEP({
                id: companyId ?? "",
                isAnonymousSociety: isAnonymousSociety === "1",
                userEmail: user.userEmail
            });
            message.success("Informação atualizada com sucesso!");
        } catch (error) {
            message.error("Erro ao atualizar informação");
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getCapitalComposition();
    }, []);
    return (
        <>
            {loading && <Loader />}
            <TabsHeader
                canValidate={true}
                valueSelected={validateField}
                changeValidate={handleValidate}
                registerId={registerId}
                cardName=""
                tabName=""
            />
            <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Cadastro Pessoa Jurídica - Proponente ou Executora</Title>
            <Text style={{ color: '#777777', fontSize: '18px', fontWeight: 'normal' }}>Informações primárias da empresa</Text>

            <Title level={5} className="mt-4 mb-4">
                <strong>Composição do Capital Social</strong>
            </Title>
            <Table
                columns={columns}
                dataSource={capitalCompositionList}
                rowKey={(record) => record.id || ''}
                bordered
                pagination={false}
                locale={{
                    emptyText: (
                        <Text type="secondary">Nenhum sócio/acionista cadastrado</Text>
                    )
                }}
                style={{ marginBottom: 24 }}
                footer={() => (
                    <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
                        <Input
                            placeholder="Capital Votante"
                            value={votingCapital}
                            onChange={(e) => setVotingCapital(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <Input
                            placeholder="CNPJ/CPF"
                            value={document}
                            onChange={(e) => setDocument(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <Input
                            placeholder="Nome Completo"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <Select
                            placeholder="Controlador"
                            value={isController ? "1" : "0"}
                            onChange={(value) => setIsController(value === "1")}
                            style={{ flex: 0.5 }}
                        >
                            <Select.Option value="1">Sim</Select.Option>
                            <Select.Option value="0">Não</Select.Option>
                        </Select>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleAddCapitalComposition}
                            disabled={!votingCapital || !document || !fullName}
                        >
                            Adicionar
                        </Button>
                    </div>
                )}
            />
            <Form.Item
                label="Em caso de sociedade anônima, há pulverização de seu capital social de modo a não se identificar o seu controlador?"
                labelCol={{ span: 24 }}
                style={{ marginBottom: 24 }}
            >
                <Select
                    style={{ width: 120 }}
                    value={isAnonymousSociety}
                    onChange={(value) => {
                        setIsAnonymousSociety(value);
                        handleChangeAnonymousSociety();
                    }}
                >
                    <Select.Option value="1">Sim</Select.Option>
                    <Select.Option value="0">Não</Select.Option>
                </Select>
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
                <Button onClick={() => changeTab(3)}>
                    Voltar
                </Button>
                <Button type="primary" onClick={() => changeTab(5)}>
                    <PlusOutlined /> Próxima Etapa
                </Button>
            </div>
        </>
    );
};
export default CapitalCompositionFinepTab;